import {
	BLOCKED,
	EXPLAIN,
	INTRO,
	NOTINTERESTED,
	OUTRO,
	REQUISITES,
	SECTIONS,
	SURVEY,
	TEST_MY_VIDEO,
	TEST_TECH,
	TEST_WEBCAM,
	TESTALREADYDONE,
	WAITINGROOM,
} from './constants';

/**
 * @typedef {INTRO | EXPLAIN | TEST_TECH | TEST_WEBCAM | TEST_MY_VIDEO | WAITINGROOM | SECTIONS | REQUISITES | OUTRO | SURVEY | BLOCKED | TESTALREADYDONE | NOTINTERESTED} TypeTemplate
 */

/**
 * @typedef {Object} TemplateWorkflow
 * @property {string} type
 * @property {string} route
 * @property {string} name?
 * @property {string} paramsRoute?
 */

/**
 * Explain? + TestTech? + TestWebcam? + TestMyVideo?
 * @param {boolean} hasVideoAnswers
 * @param {boolean} hasProctoring
 * @param {any} steps
 * @param {boolean} explain
 * @returns {TemplateWorkflow[]}
 */
export const techSteps = ({ explain = true, hasVideoAnswers, hasProctoring }) => [
	...(explain
		? [
				{
					type: EXPLAIN,
					route: '/explain',
				},
		  ]
		: []),
	...(hasVideoAnswers || hasProctoring
		? [
				{
					type: TEST_TECH,
					route: '/test_my_tech',
					name: 'checks',
				},
		  ]
		: []),
	...(hasVideoAnswers
		? [
				{
					type: TEST_WEBCAM,
					route: '/practice',
					name: 'pratice',
				},
		  ]
		: []),
	...(hasVideoAnswers ? [{ type: TEST_MY_VIDEO, route: '/test_my_video' }] : []),
];

export const requisiteStep = { type: REQUISITES, route: '/requisites' };

export const notinterested = [{ type: NOTINTERESTED, route: '/not-interested' }];
export const blocked = [{ type: BLOCKED, route: '/blocked' }];
/**
 *
 * @type {[{route: string, type: string}]}
 */
export const finished = [{ type: TESTALREADYDONE, route: '/already-done' }];
/**
 *
 * @type {[{route: string, type: TypeTemplate}]}
 */
export const waitingRoom = [{ type: WAITINGROOM, route: '/waiting-room' }];

/**
 * Only Intro
 * @param {Landing} landing data
 * @returns {TemplateWorkflow}
 */
export const introStep = (landing) => ({
	...landing,
	type: INTRO,
	route: '/welcome',
	paramsRoute: '/:token',
});

/**
 * Only Outro
 * @param {Object} outro
 * @returns {TemplateWorkflow}
 */
export const outroStep = (outro) => ({
	type: OUTRO,
	route: '/outro',
	...outro,
});

/**
 * Only Survey
 * @returns {TemplateWorkflow}
 */
export const surveyStep = {
	type: SURVEY,
	route: '/survey',
};

/**
 * Section + Requisites? + Outro
 * @param data
 * @returns {TemplateWorkflow[]}
 */
export const sectionsSteps = ({ hasRequisites, outro }) => [
	{
		type: SECTIONS,
		route: '/exam',
		paramsRoute: '/:section/:question',
	},
	...(hasRequisites ? [requisiteStep] : []),
	outroStep(outro),
];
